import React, { useContext } from 'react';
import MapContext from '../Map/MapContext';
import { useTranslation } from 'react-i18next';

const ZoomOut = () => {
  const { map } = useContext(MapContext);
  const { t } = useTranslation();

  if (!map) return null;

  const handleZoomOut = () => {
    if (map) {
      const view = map.getView();
      const currentZoom = view.getZoom();
      view.setZoom(currentZoom - 1); // Disminuye el zoom en 1 nivel
    }
  };

  return (

    <span
      className={`list-item`}
      onClick={handleZoomOut}
      style={{ cursor: 'pointer' }}
      title={t('Zoom Out')}

    >
      <svg viewBox="0 0 16 16" fill="currentColor" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" style={{overflow:'visible'}}><path fill="currentColor" d="M10 2h6v2h-6V2z"/><path fill="currentColor" d="M13.599 5H9V3.056A8.923 8.923 0 0 0 8 3C4.511 3 1.486 5.032 0 8c1.486 2.968 4.511 5 8 5s6.514-2.032 8-5a9.173 9.173 0 0 0-2.401-3zM6.5 5a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 6.5 5zm5.444 5.348a7.326 7.326 0 0 1-7.889 0A7.626 7.626 0 0 1 1.72 8a7.594 7.594 0 0 1 2.52-2.462 4 4 0 1 0 7.518 0A7.615 7.615 0 0 1 14.278 8a7.594 7.594 0 0 1-2.335 2.348z"/></svg>
    </span>
  );
};

export default ZoomOut;